module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-02-2e7d6730334fac9f819c8eb2ba13af39.png";